<template>
  <page-outline :title="$t('administration.client_details')">
    <template slot="pageContent">
      <!-- <div class="page-content infinite-scroll"
        style="z-index:9"> -->
        <div class="listPage">
          <b-row class="ml-3 mb-5">
            <b-col cols="2">
              <back-button></back-button>
            </b-col>
          </b-row>
          <!-- <div class="row"> -->
            <!-- <div class="row rowSearchBar"> -->
              <!-- Extract csv and refresh button to do asap -->
              <!-- <extract-csv-button @startCSVextraction="extractCSV(inboxMessages)"></extract-csv-button>
              <button class="showLargeScreenOnly milkyBlockBlack firstBlock new-button-white"
                      @click="refreshUBODetails()">
                <f7-icon f7="refresh"></f7-icon>
                <span class="fab-label">
                  {{ $t('common.rfrsh') }}
                </span>
              </button> -->
            <!-- </div> -->
          <!-- </div> -->
          <!-- <spinner v-if="currentSupplier.length < 0"></spinner>
          <div v-else> -->
            <f7-grid no-gutter>
              <f7-col class="pilotageTabController" :width="projectsList.length ? '33' : '50'">
                <f7-link class="pilotageLink"
                  :class="[currentTab === 'Documents' ? 'tabActive' : 'tabUnactive']"
                  @click="changeCurrentTab('Documents')"
                  tab-link=".documentsTab">
                  <span class="showLargeScreenOnly h5">
                    <i class="fa-duotone fa-file"></i>&nbsp;&nbsp;{{ $t('common.docs_label', {provider: currentSupplier.SocialReason}) }}
                  </span>
                  <span class="showSmallScreenOnly h5">
                    <i class="fa-duotone fa-file"></i>&nbsp;&nbsp;{{ $t('common.docs_label_small') }}
                  </span>
                </f7-link>
              </f7-col>
              <f7-col width="33" class="pilotageTabController" v-if="projectsList.length">
                <f7-link class="pilotageLink"
                  :class="[currentTab === 'Projects' ? 'tabActive' : 'tabUnactive']"
                  @click="changeCurrentTab('Projects')"
                  tab-link=".projectsTab">
                  <span class="showLargeScreenOnly h5">
                    <i class="fa-duotone fa-info-circle"></i>&nbsp;&nbsp;{{ $t('common.projects_label', {provider: currentSupplier.SocialReason}) }}
                  </span>
                  <span class="showSmallScreenOnly h5">
                    <i class="fa-duotone fa-info-circle"></i>&nbsp;&nbsp;{{ $t('common.projects_label_small') }}
                  </span>
                </f7-link>
              </f7-col>
              <f7-col class="pilotageTabController" :width="projectsList.length ? '33' : '50'">
                <f7-link class="pilotageLink"
                  :class="[currentTab === 'SellerInformation' ? 'tabActive' : 'tabUnactive']"
                  @click="changeCurrentTab('SellerInformation')"
                  tab-link=".sellerInformationTab">
                  <span class="showLargeScreenOnly h5">
                    <i class="fa-duotone fa-info-circle"></i>&nbsp;&nbsp;{{ $t('common.info_label', {provider: currentSupplier.SocialReason}) }}
                  </span>
                  <span class="showSmallScreenOnly h5">
                    {{ $t('common.info_label_small') }}
                  </span>
                </f7-link>
              </f7-col>
            </f7-grid>
          </div>

          <spinner v-if="activatePaymentsSpinner"></spinner>
          <f7-tabs v-else>
            <f7-tab class="documentsTab" no-gutter :active="projectsList.length === 0">
              <spinner v-if="activateProviderSpinner"></spinner>
              <div class="" v-else>
                <document-general-info
                  v-for="document in documentsList"
                  :key="document.IdDocument"
                  v-if="document.Type !== 'PROOF_OF_ADDRESS'"
                  :document="document"
                  :seller="currentSupplier"
                  :shareholder="false">
                </document-general-info>
                <div class="shareholderNumberLine" v-if="false">
                  <div class="shareholderNumberLineTitleQuestion showLargeScreenOnly">
                    {{ $t('suppliers.nb_of_shareholders') }}
                  </div>
                  <div class="shareholderNumberLineTitleQuestion showSmallScreenOnly"
                    style="grid-column-start: 1;grid-column-end: 3;">
                    {{ $t('suppliers.nb_of_shareholders') }}
                  </div>
                  <div class="selectionBlocLine showLargeScreenOnly">
                    <div v-for="availableNumber in availableShareholderNumber"
                      class="selectionBloc" @click="updateNumberOfShareholder(availableNumber, $event)"
                      :class="{selectionBlocActive : numberOfShareholder === availableNumber}">
                      {{ availableNumber }}
                    </div>
                  </div>
                  <div class="selectionBlocLine showSmallScreenOnly"
                    style="grid-column-start: 1;grid-column-end: 3;">
                    <div v-for="availableNumber in availableShareholderNumber"
                      class="selectionBloc" @click="updateNumberOfShareholder(availableNumber, $event)"
                      :class="{selectionBlocActive : numberOfShareholder === availableNumber}">
                      {{ availableNumber }}
                    </div>
                  </div>
                  <div class="importFileButton">
                    <span class="fileClickButton" @click="callUBOinstitutionalSource($event)">
                      {{ $t('suppliers.ask_institut_UBO') }}
                    </span>
                  </div>
                </div>
                <div v-for="shareholder in shareholders"
                  :key="shareholder.orderNumber" :expanded="!shareholder.IsLegalRepresentative">
                  <div class="accordionTitleInformation background-supplier-document-form">
                    <div class="shareholdersInformationGrid">
                      <div class="shareholderDocumentsTitle showLargeScreenOnly">
                        {{ $t('common.nme') }} :
                        <span v-if="shareholder.Source !== 'Manuel'">{{ shareholder.LastName }}</span>
                        <input type="text" class="nameFormControl"
                          v-else
                          v-model="shareholder.LastName"
                          :placeholder="$t('suppliers.shareholder_lastname_placeholder') + ' ' + shareholder.OrderNumber">
                        </input>
                      </div>
                      <div class="shareholderDocumentsTitle showSmallScreenOnly"
                        style="grid-column-start: 1;grid-column-end: 3;">
                        {{ $t('common.nme') }} :
                        <span v-if="shareholder.Source !== 'Manuel'">{{ shareholder.LastName }}</span>
                        <input type="text" class="nameFormControl" style="float: right;"
                          v-else
                          v-model="shareholder.LastName"
                          :placeholder="$t('suppliers.shareholder_lastname_placeholder') + ' ' + shareholder.OrderNumber">
                        </input>
                      </div>
                      <div class="shareholderDocumentsTitle showLargeScreenOnly">
                        {{ $t('common.fist_nm') }} :
                        <span v-if="shareholder.Source !== 'Manuel'">{{ shareholder.FirstName }}</span>
                        <input type="text" class="nameFormControl"
                          v-else
                          v-model="shareholder.FirstName"
                          :placeholder="$t('suppliers.shareholder_firstname_placeholder') + ' ' + shareholder.OrderNumber"
                          :disabled="shareholder.Source !== 'Manuel'">
                        </input>
                      </div>
                      <div class="shareholderDocumentsTitle showSmallScreenOnly"
                        style="grid-column-start: 1;grid-column-end: 3;">
                        {{ $t('common.fist_nm') }} :
                        <span v-if="shareholder.Source !== 'Manuel'">{{ shareholder.FirstName }}</span>
                        <input type="text" class="nameFormControl" style="float: right;"
                          v-else
                          v-model="shareholder.FirstName"
                          :placeholder="$t('suppliers.shareholder_firstname_placeholder') + ' ' + shareholder.OrderNumber">
                        </input>
                      </div>
                      <div class="percentageDetentionLabel">
                        {{ $t('suppliers.percentage_detention') }}
                        <span v-if="shareholder.Source !== 'Manuel'">{{ shareholder.PercentageDetention }}</span>
                        <input type="text" class="miniFormControl"
                          v-else
                          v-model="shareholder.PercentageDetention"
                          :disabled="shareholder.Source !== 'Manuel'">
                          %
                        </input>
                      </div>
                      <div class="isLegalRepresentativeLabel">
                        <b-form-checkbox
                          v-if="shareholder.Source !== 'Manuel'"
                          :disabled="(oneShareholderIsLegalRepresentative && shareholder != null &&
                                    !shareholder.IsLegalRepresentative) ||
                                    shareholder.Source !== 'Manuel'"
                          v-model="shareholders[shareholder.OrderNumber - 1].IsLegalRepresentative"
                          :value="1" :unchecked-value="0">
                          {{ $t('suppliers.is_legal_representative_label') }}
                        </b-form-checkbox>
                        <a href="#" @click="removeShareholder(shareholder)"
                          v-if="shareholder.Source === 'Manuel'"
                          :title="$t('suppliers.remove_shareholder')">
                          <i class="icon button-delete f7-icons" style="margin-right: -10px;margin-top: -2px;">close</i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="!shareholder.IsLegalRepresentative">
                    <document-general-info
                      v-for="document in shareholder.Documents"
                      v-if="updatedShareholders"
                      :key="document.IdDocument"
                      :document="document"
                      :seller="currentSupplier"
                      :shareholder="shareholder">
                    </document-general-info>
                  </div>
                </div>
                <div v-if="parseInt(numberOfShareholder) < (availableShareholderNumber.length - 1)"
                  class="addShareholderLine"
                  style="display:none" @click="addShareholder">
                  <i class="fa-light fa-plus" style="margin-top: -2px;"></i>
                  {{ $t('suppliers.add_shareholder') }}
                </div>
                <b-row class="row justify-content-start no-gutter mt-3">
                  <b-col cols="2" offset="10">
                    <b-button v-if="currentSupplier.Status !== '31'"
                      size="lg"
                      variant="primary"
                      @click="updateFolderStatus('31')">
                      <i class="fa-light fa-check"></i>
                      {{ $t('suppliers.close_doc_group') }}
                    </b-button>
                    <h5 v-if="currentSupplier.Status === '31'" class="float-right text-success mt-3 font-weight-bold">
                      Compte Client Vérifié
                      <i class="fa-solid fa-check text-success"></i>
                    </h5>
                    <!-- <button round v-if="currentSupplier.Status === '31'"
                      class="button-action milkyBlockBlack"
                      @click="getExchangeGroupDocument(currentSupplier.GroupDocumentId)">
                      <i class="icon fa fa-check"></i>
                      {{ 'Télécharger le rapport' }}
                    </button> -->
                  </b-col>
                </b-row>
              </div>

            </f7-tab>

            <f7-tab class="projectsTab" no-gutter v-if="projectsList.length" :active="projectsList.length > 0">
              <cm-messages-filter
                class="researchfilter"
                style="position:relative;z-index:10"
                :isPayments="true"
                :received="true"
                :filterType="'list'"
                @applyFilter="applyFilter($event)"
                :aloneTab="false"
                :propedServiceId="'6'">
              </cm-messages-filter>

              <project-details :projectsInformation="projectsList">
              </project-details>

              <cm-pagination
                :firstIndex="paginationObject.firstIndex"
                :maxResultsByPage="paginationObject.maxResults"
                :nbResultsTotal="paginationObject.nbResultsTotal"
                :refreshEvent="paginationObject.refresh">
              </cm-pagination>
            </f7-tab>

            <f7-tab class="sellerInformationTab" no-gutter>
              <!-- <div class="sellerInformationTitle">
                <h4>{{ currentSupplier.SocialReason }}</h4>
              </div> -->
              <!-- <div class="two-column-grid-container"> -->
              <b-container>
                  <b-row class="form-group"
                    v-for="key in showableSupplierData" :key="key"
                    v-if="currentSupplier[key] && currentSupplier[key] !== ''">
                    <!-- <form-read-group-label-input
                      :inputLabel="$t('suppliers.general_info.' + key)"
                      :inputValue="showSellerDetailValue(key, currentSupplier[key])"
                      :statusIcon="getStatusIcon(key, currentSupplier[key])">
                    </form-read-group-label-input> -->
                    <!-- <div> -->
                      <b-col cols="3">
                        <label :for="key + '_input'">{{$t('suppliers.general_info.' + key)}}</label>
                      </b-col>
                      <b-col cols="9">
                        <input disabled="true" class="form-control" type="text" :value="showSellerDetailValue(key, currentSupplier[key])" />
                      </b-col>
                    <!-- </div> -->
                  </b-row>
              </b-container>
              <!-- </div> -->
            </f7-tab>
          </f7-tabs>
          <div class="toolbarPageBottomBlank"></div>
        <!-- </div> -->
      <!-- </div> -->
    </template>
  </page-outline>
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import ExtractCSVbutton from '@/components/common/extractCSVbutton.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import MessagesFilter from '@/components/common/Filter'
import pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import ProjectDetails from '@/pages/requests/detailPages/supplierDetailPages/ProjectDetails.vue'
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import DocumentGeneralInfo from '@/pages/requests/detailPages/supplierDetailPages/DocumentGeneralInfo.vue'

import legalStatusList from '../../creationPages/data/legalstatus.json'

import {errorMessageAlert} from '@/helpers/alert'
import { statusIcon, statusLabel } from '@/helpers/labels'

export default {
  name: 'SupplierDetailPage',
  components: {
    'back-button': backButton,
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'document-general-info': DocumentGeneralInfo,
    'extract-csv-button': ExtractCSVbutton,
    'form-read-group-label-input': formReadGroupLabelInput,
    'project-details': ProjectDetails,
    'spinner': Spinner,
    'transactions-list': TransactionsList,
    'page-outline': PageOutline
  },
  data () {
    return {
      activatePaymentsSpinner: false,
      activateProviderSpinner: false,
      availableShareholderNumber: ['0', '1', '2', '3', '4'],
      currentSupplier: {},
      currentTab: 'Documents',
      detailsDone: false,
      documentsList: [],
      legalStatusList: legalStatusList,
      numberOfShareholder: '0',
      openedShareholderAccordion: false,
      paginationObject: {},
      projectsList: [],
      serviceId: this.$engine.user.currentService.id.toString(),
      shareholders: [],
      showableSupplierData: ['Name', 'Status', 'Bic', 'Email', 'SellerIdentifier',
        'Siren', 'SocialReason', 'LegalForm', 'StreetName', 'TownName'],
      updatedShareholders: true
    }
  },
  created () {
    this.currentSupplier = this.$engine.services.suppliers.selectedSupplier
    this.getFolderDetails()
    // pagination to do
    // this.paginationObject['firstIndex'] = 1
    // this.paginationObject['maxResults'] = 10
    // this.paginationObject['nbResultsTotal'] = 0
    // this.paginationObject['refresh'] = 'direct-inbox-filtered'
    // this.getPaymentsList()
  },
  computed: {
    oneShareholderIsLegalRepresentative () {
      let oneSHisRepresentative = false
      this.shareholders.map(holder => {
        if (holder.IsLegalRepresentative) {
          oneSHisRepresentative = true
        }
      })
      return oneSHisRepresentative
    }
  },
  methods: {
    addShareholder () {
      this.numberOfShareholder = (parseInt(this.numberOfShareholder) + 1).toString()
      this.shareholders.push({
        IsLegalRepresentative: 0,
        OrderNumber: this.numberOfShareholder,
        PercentageDetention: '25',
        FirstName: '',
        LastName: '',
        Source: 'Manuel',
        Documents: [{
          Type: 'IDCARD',
          Status: 0,
          Serialize: {}
        }, {
          Type: 'PROOF_OF_ADDRESS',
          Status: 0,
          Serialize: {}
        }]
      })
    },
    applyDocumentsFilter (filterConditions) {
      if (filterConditions.uboStatus) {
        filterConditions.uboStatus = JSON.stringify(filterConditions.uboStatus)
      }
      this.detailsDone = false
      this.activateProviderSpinner = true
      this.getSupplierInfo()
      this.getFolderDetails(filterConditions)
    },
    callUBOinstitutionalSource (e) {
      e.stopPropagation()
      // this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.currentSupplier.Siren,
        RepeatOnlyPP: '1',
        SaveDatabase: '1',
        IdExchangeGroup: this.currentSupplier.IdGroupDocument
      }
      let that = this
      this.$engine.services.suppliers.getUBOFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          if (response.data.Beneficial != null) {
            // that.numberOfShareholder = response.data.Beneficial.length.toString()
            // that.shareholders = []
            // for (let i = 0; i < response.data.Beneficial.length; i++) {
            //   that.shareholders.push({
            //     IsLegalRepresentative: 0,
            //     OrderNumber: i + 1,
            //     FirstName: response.data.Beneficial[i].FirstName,
            //     LastName: response.data.Beneficial[i].LastName,
            //     FullName: response.data.Beneficial[i].FirstName + ' ' + response.data.Beneficial[i].LastName,
            //     PercentageDetention: response.data.Beneficial[i].PercentageDetention,
            //     Documents: [{
            //       Type: 'IDCARD',
            //       Status: 0
            //     }, {
            //       Type: 'PROOF_OF_ADDRESS',
            //       Status: 0
            //     }]
            //   })
            // }
            this.getFolderDetails({}, true)
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    changeCurrentTab (newTab) {
      if (this.currentTab !== newTab) {
        this.currentTab = newTab
      }
    },
    extractCSV (docList) {
      // to do asap
    },
    getExchangeGroupDocument (groupId) {
      let downloadLink = document.createElement('a')
      let that = this
      downloadLink.download = 'rapportKYC.pdf'
      this.$engine.services.suppliers.getBusinessFolder({
        groupIdFonctionnal: groupId
      })
      .then(resp => {
        if (resp.status === 200) {
          downloadLink.href = resp.data.document
          downloadLink.click()
        }
      })
      .catch(error => {
        this.$f7.hidePreloader()
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getFolderDetails (filterConditions = {}, loadingUBOafterSourceCalled = false) {
      // let that = this
      // that.updatedShareholders = false
      // console.log(this.currentSupplier)
      // // console.log('---------',this.currentSupplier[0].id_seller)
      // this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      // this.$engine.services.suppliers.getDocuments(
      //   this.currentSupplier.IdSeller,
      //   filterConditions
      // )
      // .then(resp => {
      //   this.currentSupplier = resp.data.Sellers[0]
      //   if (!loadingUBOafterSourceCalled) {
      //     that.documentsList = resp.data.Sellers[0].Documents
      //   }
      //   if (resp.data.Sellers[0].UBO != null) {
      //     that.numberOfShareholder = resp.data.Sellers[0].UBO.length.toString()
      //     that.shareholders = resp.data.Sellers[0].UBO
      //     for (let i = 0; i < resp.data.Sellers[0].UBO.length; i++) {
      //       that.shareholders[i].OrderNumber = i + 1
      //     }
      //     that.updatedShareholders = true
      //   }
      //   that.activateProviderSpinner = false
      //   that.detailsDone = true
      //   this.$f7.hidePreloader()
      // })
      // .catch(error => {
      //   errorMessageAlert(error, that, that.$i18n)
      //   this.$f7.hidePreloader()
      // })
      let that = this
      that.updatedShareholders = false
      filterConditions.IdSeller = this.currentSupplier.IdSeller
      filterConditions.Details = '1'
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      this.$engine.services.suppliers.getSupplierInfo(
        filterConditions
      )
      .then(resp => {
        this.currentSupplier = resp.data.Sellers[0]
        if (!loadingUBOafterSourceCalled) {
          that.documentsList = resp.data.Sellers[0].Documents
        }
        if (resp.data.Sellers[0].UBO != null) {
          that.numberOfShareholder = resp.data.Sellers[0].UBO.length.toString()
          that.shareholders = resp.data.Sellers[0].UBO
          for (let i = 0; i < resp.data.Sellers[0].UBO.length; i++) {
            that.shareholders[i].OrderNumber = i + 1
          }
          that.updatedShareholders = true
        }
        that.activateProviderSpinner = false
        that.detailsDone = true
        this.$f7.hidePreloader()
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getPaymentsList (index = 1) {
      // To uncomment when the model will be available
      this.pageCounter = 0
      this.paginationObject.firstIndex = index
      this.activatePaymentsSpinner = true

      this.$engine.services.suppliers.getPaymentGroups({
        IdSeller: this.currentSupplier.IdSeller
      }).then(resp => {
        this.projectsList = resp.data.groups
        if (this.projectsList.length > 0) {
          this.currentTab = 'Projects'
        }
        this.activatePaymentsSpinner = false
      }).catch(error => {
        this.activatePaymentsSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })

      // let showProjects = true
      // if (showProjects) {
      //   this.currentTab = 'Projects'
      // } else {
      //   this.projectsList = []
      // }
      // this.activatePaymentsSpinner = false
    },
    getStatusIcon (keyType, status) {
      if (keyType === 'Status') {
        return statusIcon(status)
      }
      return ''
    },
    getSupplierInfo () {
      let that = this
      this.$engine.services['suppliers'].update(
        '',
        1000,
        1,
        this.$engine.services['suppliers'].filter.getConditionObject()
      ).then(resp => {
        let suppliers = resp.data.suppliers
        for (var i = 0; i < suppliers.length; i++) {
          if (suppliers[i].idgroup === that.$engine.services.suppliers.currentSendbox.idgroup) {
            that.$engine.services.suppliers.currentSendbox = suppliers[i]
            that.currentSupplier = that.$engine.services.suppliers.currentSendbox
            break
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    refreshUBODetails: function (noAttach = false, index = 1) {
      this.detailsDone = false
      this.activateProviderSpinner = true
      this.getSupplierInfo()
      this.getFolderDetails()
    },
    removeShareholder (shareholder) {
      if (shareholder.IdUBO !== undefined) {
        let that = this
        that.$engine.services.suppliers.deleteUBO({
          IdUBO: shareholder.IdUBO
        })
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.UBO_deleted_success'),
              text: '<i class="icon fa fa-check"></i>'
            })
            this.shareholders.splice(shareholder.OrderNumber - 1, 1)
            for (let i = shareholder.OrderNumber - 1; i < this.shareholders.length; i++) {
              this.shareholders[i].OrderNumber -= 1
            }
            this.numberOfShareholder = (parseInt(this.numberOfShareholder) - 1).toString()
            setTimeout(function () {
              that.$f7.closeModal()
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        // to do : show confirmation alert
        this.shareholders.splice(shareholder.OrderNumber - 1, 1)
        for (let i = shareholder.OrderNumber - 1; i < this.shareholders.length; i++) {
          this.shareholders[i].OrderNumber -= 1
        }
        this.numberOfShareholder = (parseInt(this.numberOfShareholder) - 1).toString()
      }
    },
    showSellerDetailValue (keyType, value) {
      if (keyType === 'Status') {
        return statusLabel(this.$i18n, 'Provider_' + value)
      }
      if (keyType === 'LegalForm') {
        var foundLabel = ''
        this.legalStatusList['FR'].map(legalStatus => {
          if (value === legalStatus.code) {
            foundLabel = legalStatus.label
          }
        })
        return foundLabel
      }
      return value
    },
    updateFolderStatus (newFolderStatus) {
      // alert('shareholders')
      console.log(this.currentSupplier)
      let that = this
      // this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      that.$engine.services.businessDocuments.updateFolderStatus({
        groupId: this.currentSupplier.IdGroupDocument,
        status: newFolderStatus
      }).then(response => {
        this.$f7.hidePreloader()
        if (response.status === 200) {
          that.$f7.modal({
            title: this.$t('businessDocuments.updated_folder'),
            text: '<span class="preloader"></span>'
          })
          that.currentSupplier.Status = newFolderStatus
          setTimeout(function () {
            that.$f7.closeModal()
          }, 1000)
        }
      }).catch(error => {
        this.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    updateNumberOfShareholder (newNumber, e) {
      if (this.openedShareholderAccordion) {
        e.stopPropagation()
      }

      // Adding new shareholders to the current list
      // if (parseInt(newNumber) > parseInt(this.numberOfShareholder)) {
      //   for (let i = parseInt(this.numberOfShareholder) + 1; i <= parseInt(newNumber); i++) {
      //     this.shareholders.push({
      //       IsLegalRepresentative: 0,
      //       OrderNumber: i,
      //       PercentageDetention: '25',
      //       FirstName: '',
      //       LastName: '',
      //       Source: 'Manuel',
      //       Documents: [{
      //         Type: 'IDCARD',
      //         Status: 0
      //       }, {
      //         Type: 'PROOF_OF_ADDRESS',
      //         Status: 0
      //       }]
      //     })
      //   }
      // } else if (parseInt(newNumber) < parseInt(this.numberOfShareholder)) {
      //   // If the new number is lower than previous number, then popping until the newnumber is reached
      //   for (let i = parseInt(this.numberOfShareholder); i > parseInt(newNumber); i--) {
      //     this.shareholders.pop()
      //   }
      // }
      // this.numberOfShareholder = newNumber
    }
  }
}
</script>
<style scoped>
.container {
  max-width: 1060px;
}
</style>
